import { times } from 'lodash';

export default function naturalNumbersArray(size) {
  const array = [];
  times(size, (number) => { array.push(number + 1); });

  return array;
}
